<template>
  <f7-page name="druzice" style="position:relative;" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Družice</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template>
      <f7-toolbar bottom v-if="isImagesLoaded">
        <f7-block class="druzice-toolbar">
          <f7-row>
            <f7-col width="15">
              <f7-button class="druzice-settings" :disabled="!isImagesLoaded" sheet-open=".druzice-settings-sheet" icon-f7="slider_horizontal_3"></f7-button>
            </f7-col>
            <f7-col width="15" class="druzice-time">
              {{ currentItemTime }}
            </f7-col>
            <f7-col width="55">
              <f7-range
                  class="druzice-range"
                  ref="druziceRangeSlider"
                  :min="1"
                  :max="this.druziceMaxImages"
                  :step="1"
                  :value="this.currentImageIndex"
                  color="blue"
                  :disabled="(!isImagesLoaded || isPlaying)"
                  @range:change="rangeChanged"
              ></f7-range>
            </f7-col>
            <f7-col width="15">
              <f7-button class="druzice-play-btn" :disabled="!isImagesLoaded" @click="animPlay()" :icon-f7="playIcon"></f7-button>
            </f7-col>

          </f7-row>
        </f7-block>
      </f7-toolbar>

      <f7-sheet class="druzice-settings-sheet">
        <f7-toolbar>
          <div class="left ml-1 font-weight-bold">Nastavenia</div>
          <div class="right">
            <f7-link sheet-close>Zavrieť</f7-link>
          </div>
        </f7-toolbar>
        <!-- Scrollable sheet content -->
        <f7-page-content>
          <f7-list inline-labels no-hairlines-md class="no-margin-top">
            <f7-list-input
                label="Produkt"
                type="select"
                :value="druziceType"
                @change="onChangeDruziceType($event)"
            >
              <optgroup v-for="(group) in druziceProducts" :label="group.group_name" :key="group.group_order">
                <option v-for="product in group.items" :value="product.product_id" :key="product.product_id">
                  {{ product.product_name }}
                </option>
              </optgroup>
              <!-- option v-for="(item, index) in druziceDataFiltered" :key="item.product" :value="item.product" :title="item.product_desc">{{ item.product_name }}</option-->
            </f7-list-input>
            <f7-list-input
                label="Počet snímok"
                type="select"
                :value="druziceNumImages"
                @change="onChangeDruziceNumImages($event)"
            >
              <option v-for="(item, index) in listNumImages" :value="item">{{ item }}</option>
            </f7-list-input>
            <f7-list-input
                label="Interval"
                type="select"
                :value="druziceInterval"
                @change="onChangeDruziceInterval($event)"
            >
              <option v-for="(item, index) in listInterval" :value="item.value">{{ item.text }}</option>
            </f7-list-input>

            <f7-list-input
                :input="false"
                label="Rýchlosť"
            >
              <f7-range slot="input"
                        @range:change="onChangeDruziceAnimSpeed($event)"
                        :value="this.druziceAnimSpeed" :min="3" :max="10" :step="1"></f7-range>
            </f7-list-input>
          </f7-list>

        </f7-page-content>
      </f7-sheet>


      <l-map :options="mapOptions"
             ref="druziceMap"
             @ready="initMap()"
      >
        <l-control-zoom position="bottomright"></l-control-zoom>
        <l-image-overlay
            ref="layerImg"
            :url="imageUrl"
            :bounds="imageBounds"
            :maxBounds="imageBounds"
            :center="[0,0]"
        />
      </l-map>

      <!--pinch-zoom ref="refDruziceZoom" style="position: relative;" limitPan="true" overflow="visible" disableZoomControl="disable" limitZoom="5" backgroundColor="rgba(255,255,255,1)">
        <img :src="imageUrl" class="druzice-image position-relative">
      </pinch-zoom-->

    </template>
    <image-preloader
        :srcs="imagesToPreload"
        @loaded-all="imageLoadedAll"
        @loaded="imageLoadedOne"
        @onerror="imagePreloadError"
    />



  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import imagePreloader from '../components/imagePreloader'
import {LControlZoom, LImageOverlay, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import PinchZoom from "vue-pinch-zoom";

var progressDialog, loadingDialog;

export default {
  components: {
    'image-preloader': imagePreloader,
    'pinch-zoom': PinchZoom,
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LControlZoom
  },
  data: function () {
    return {
      druziceData: [],
      listNumImages: [4, 12, 24, 48],
      listInterval: [
        {value: 15, text: '15 min.'},
        {value: 30, text: '30 min.'},
        {value: 60, text: '1 hod.'}
      ],
      isDataLoaded: false,
      isImagesLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      playIcon: 'play_fill',
      isPlaying: false,
      currentItemTime: '00:00',
      imagesToWalk: [],
      imagesToWalkLightning: [],
      preloaderLoaded: 0,
      currentImageIndex: 1,
      imageUrl: 'static/shmu/img/blank.png',
      base_url: '',
      animTimer: null,
      stopTimer: null,
      druziceType: '147',
      druziceNumImages: 4,
      druziceMaxImages: 4,
      druziceInterval: 15,
      druziceAnimSpeed: 9,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        minZoom: 1,
        maxZoom: 4,
        zoom: 2,
        crs: L.CRS.Simple

      },
      imageBounds: [[85.05, -31.46], [65.585, -180]]

    };
  },
  watch: {
    isPlaying: function (val) {
      if (val === true) {
        this.playIcon = 'pause_fill';
      } else {
        this.playIcon = 'play_fill';
      }
    },
    druziceAnimSpeed(val) {
      if (this.isPlaying) {
        this.animPlay(); // zastavime
        this.animPlay(); // spustime
      }
    },
    imagesToWalk(val) {
      this.druziceMaxImages = val.length;
    },
  },
  computed: {

    druziceProducts() {
      let res = [];
      this.druziceData.forEach(item => {
        let g_name = item.product_group;
        let g_order = item.group_order;


        let processed_group = res.find(group => { return group.group_name === g_name });
        if (processed_group) {
          processed_group.items.push({
            product_id: item.product,
            product_name: item.product_name,
            product_order: item.product_order,
          });
        } else {
          processed_group = { group_name: g_name, group_order: g_order, items: [] };
          processed_group.items.push({
            product_id: item.product,
            product_name: item.product_name,
            product_order: item.product_order,
          });

          res.push(processed_group);
        }

      });

      res.sort((a, b) => (a.group_order > b.group_order) ? 1 : -1);
      res.forEach(group => {
        group.items.sort((a, b) => (a.product_order > b.product_order) ? 1 : -1);
      })


      return res;
    },
    druziceDataFiltered() {
      return this.druziceData.filter((item) => item.product !== 'data.lightning');
    },
    animSpeed() {
      return (11 - this.druziceAnimSpeed) * 100;
    },
    imagesToPreload() {
      let finalToLoad = [];

      if (this.druziceData.length > 0) {
        let obj = this.druziceData.find((item) => item.product === this.druziceType);

        if (obj && obj.items.length > 0) {
          this.base_url = obj.base_url;

          let tmp = obj.items.sort((a, b) => (a.dt < b.dt) ? 1 : -1);
          let first_dt = tmp[0].dt;
          let tmp3 = [];
          let tmp4 = [];

          if (this.druziceType === '049') { // ak je to vegetacny index, dame 30 zaznamov
            tmp3 = tmp.slice(0, 30);
          } else {

            if (this.druziceInterval > 15) {
              let to_max = first_dt - (this.druziceNumImages * this.druziceInterval * 60);
              for (let z = first_dt; z > to_max; z = z - (this.druziceInterval * 60)) {
                let obj_w = tmp.find((item) => item.dt === z);
                if (obj_w) {
                  tmp3.push(obj_w);
                }
              }
            } else {
              tmp3 = tmp.slice(0, this.druziceNumImages);
            }
          }

          this.imagesToWalk = tmp3.sort((a, b) => (a.dt > b.dt) ? 1 : -1);
          this.imagesToWalk.forEach((v) => {
            finalToLoad.push(obj.base_url + v.fname);
          });

          if (finalToLoad.length > 0) {
            progressDialog = this.$f7.dialog.progress('Načítavam snímky...', 0);
          }
        }
        return finalToLoad;
      }
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

    // nacitanie zapamatanych parametrov
    if (this.$ls.get('druzice_type') !== null) {
      this.druziceType = this.$ls.get('druzice_type');
    }

    if (this.$ls.get('druzice_num_images') !== null) {
      this.druziceNumImages = parseInt(this.$ls.get('druzice_num_images'));
    }

    if (this.$ls.get('druzice_anim_speed') !== null) {
      this.druziceAnimSpeed = parseInt(this.$ls.get('druzice_anim_speed'));
    }

    if (this.$ls.get('druzice_interval') !== null) {
      this.druziceInterval = parseInt(this.$ls.get('druzice_interval'));
    }

    this.$nextTick(() => {
      this.initMap();
    });


  },
  updated: function () {
    const self = this;
    this.$nextTick(function () {
      if (self.$f7.range.get('.druzice-range')) {
        if (this.druziceMaxImages != self.$f7.range.get('.druzice-range').max) {
          self.$f7.range.get('.druzice-range').max = this.druziceMaxImages;
        }
      }
    })
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        loadingDialog = self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getsatellitedata', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.druziceData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 1000); // overujem kazdu minutu
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať družicové informácie', 'Nastala chyba');
              }

              loadingDialog.close();
              loadingDialog = null;
            }).catch((error) => {
          loadingDialog.close();
          loadingDialog = null;
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },

    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 3 * 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    imageLoadedOne(e) {
      progressDialog.setProgress(e.progress);
      progressDialog.setText(e.count + ' z ' + e.length);
    },
    imageLoadedAll(e) {
      progressDialog.close();
      progressDialog = null;
      this.isImagesLoaded = true;
      this.setImage(this.druziceMaxImages);

      this.$nextTick(() => {
        this.$$('.druzice-range, .range-slider, .range-bar, .range-knob, .range-knob-wrap, .range-bar-active').on('click', this.druziceRangeClicked);
      });

    },
    imagePreloadError(e) {
      const self = this;
      if (progressDialog !== null) {
        progressDialog.close();
        progressDialog = null;
      }
      this.isImagesLoaded = true;
      this.setImage(this.druziceMaxImages);

      this.$nextTick(() => {
        this.$$('.druzice-range, .range-slider, .range-bar, .range-knob, .range-knob-wrap, .range-bar-active').on('click', this.druziceRangeClicked);
      });

      self.$f7.dialog.alert('Niektoré obrázky sa nepodarilo načítať.', 'Nastala chyba');
      console.log('Nepodarilo sa nacitat: ',  e.errorImgs);
    },
    rangeChanged(val) {
      if (!this.isPlaying) {
        this.setImage(val);
      }
    },
    druziceRangeClicked(e) {
      if (this.isPlaying) {
        this.isPlaying = false;
        clearInterval(this.animTimer);
      }
    },
    onChangeDruziceType(e) {
      this.druziceType = e.target.value;
      this.imagesLoaded = false;

      this.$ls.set('druzice_type', this.druziceType);
    },
    onChangeDruziceNumImages(e) {
      this.druziceNumImages = parseInt(e.target.value);
      this.$ls.set('druzice_num_images', this.druziceNumImages);
    },
    onChangeDruziceInterval(e) {
      this.druziceInterval = parseInt(e.target.value);
      this.$ls.set('druzice_interval', this.druziceInterval);
    },
    onChangeDruziceAnimSpeed(e) {
      this.druziceAnimSpeed = e;
      this.$ls.set('druzice_anim_speed', parseInt(this.druziceAnimSpeed));
    },
    setImage(i) {
      if (i >= this.druziceMaxImages) {
        i = this.druziceMaxImages;
      }
      this.currentImageIndex = i;
      let fname = '';
      let dt;
      this.imagesToWalk.forEach((v, ii) => {
        if (ii + 1 === i) {
          fname = v.fname;
          dt = v.dt;
          return;
        }
      });
      if (fname !== '') {
        this.imageUrl = this.base_url + fname;
        this.currentItemTime = this.$moment.unix(dt).format('HH:mm');
      }
    },
    anim() {
      this.animTimer = setInterval(() => {
        if (this.currentImageIndex === this.druziceMaxImages) {
          clearInterval(this.animTimer);
          this.restartAnimPlay(1);
          // this.setImage(1);
        } else {
          this.setImage(this.currentImageIndex + 1);
        }

      }, this.animSpeed)
    },
    animPlay() {
      if (this.isPlaying) {
        clearInterval(this.animTimer);
        clearTimeout(this.stopTimer);
        this.isPlaying = false;
      } else {
        this.isPlaying = true;
        this.anim();
      }
    },
    restartAnimPlay(index) {
      const self = this;
      this.stopTimer = setTimeout(function(){
        self.setImage(index);
        self.anim();
      }, this.animSpeed * 1.75)
    },
    onPageBeforeOut() {
      const self = this;
      clearInterval(this.animTimer);
      clearTimeout(this.stopTimer);
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.sheet.close();
    },
    onPageBeforeRemove() {
      const self = this;
      clearInterval(this.animTimer);
      clearTimeout(this.stopTimer);
      // console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.sheet) self.sheet.destroy();
    },
    initMap() {
      const self = this;
      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      let w = 845;
      let h = 525;

      if (this.$refs.druziceMap) {
        let map = this.$refs.druziceMap.mapObject;
        let southWest = map.unproject([0, h], map.getMaxZoom() - 1);
        let northEast = map.unproject([w, 0], map.getMaxZoom() - 1);
        self.imageBounds =  new L.LatLngBounds(southWest, northEast);
        map.setMaxBounds(self.imageBounds);
      }


    },


  }



}
</script>

<style lang="scss">

.druzice-time {
  font-weight: bold;
  font-size:1.1rem;
}

.md {
  .druzice-time {
    padding-top:0.4rem;
  }

  .druzice-settings {
    padding-top:0.3rem;
    margin-left:0.5rem;
  }

  .druzice-play-btn {
    padding-top: 0.3rem;
    padding-left: 0.5rem;
  }

  .druzice-range {
    padding-top: 1.1rem;
  }
}
.druzice-toolbar {
  max-width:400px;
  width:100%;
  margin: 0px auto;
}


</style>
